import React, { MutableRefObject, useEffect, useRef } from 'react'
import { IonRow } from '@ionic/react'
import Buttonwall from './Buttonwall.content'
import BurnsSegment from './BurnsSegment.content'
import BurnsSummary from './BurnsSummary.content'
import { getBodyViewSelector } from '../../selectors/getBodyViewSelector'
import { useDispatch, useSelector } from 'react-redux'
import './BurnsTbsa.content.css'
import { setCurrentSelectedObj, setRange } from '../../store/burns.actions'
import { IBurnsExamDataOptions } from '../../store/burns.types'
import { anteriorlocations, posteriorlocations } from '../../data/data'
import AdditionalBurns from '../../additionalBurns/AdditionalBurns.content'
import useDeviceMetrics from '../../../../../../utilities/useDeviceMetrics'

const BurnsTbsaContent: React.FC = () => {
  const selectedBodyView = useSelector(getBodyViewSelector)
  const selectorRef: MutableRefObject<HTMLElement | null> = useRef(null)
  const dispatch = useDispatch()
  const { isTabletInLandscape } = useDeviceMetrics()
  const handleOutsideClick = (event: any) => {
    if (selectorRef.current && !selectorRef.current.contains(event.target)) {
      dispatch(setCurrentSelectedObj(null))
      dispatch(setRange(0))
    }
  }

  useEffect(() => {
    window.addEventListener('mousedown', handleOutsideClick)
    return () => {
      window.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const bodySurveyLocations: IBurnsExamDataOptions = selectedBodyView?.id === 1 ? anteriorlocations : posteriorlocations

  return (
    <>
      <BurnsSummary />
      <BurnsSegment />
      <IonRow className='w-100 gray-bg mb-5'>
        {bodySurveyLocations.map((location) => {
          const { locationId, locationName, buttonArr } = location
          return (
            <Buttonwall
              key={locationId + locationName}
              locationId={locationId}
              buttonArr={buttonArr}
              rowTitle={location.locationName}
              selectorRef={selectorRef}
            />
          )
        })}
      </IonRow>
      {!isTabletInLandscape && <AdditionalBurns />}
    </>
  )
}
export default BurnsTbsaContent
